import { render } from "./PRPMicroneedlingFacialContentEs.vue?vue&type=template&id=95e67452&scoped=true"
import script from "./PRPMicroneedlingFacialContentEs.vue?vue&type=script&lang=js"
export * from "./PRPMicroneedlingFacialContentEs.vue?vue&type=script&lang=js"

import "./PRPMicroneedlingFacialContentEs.vue?vue&type=style&index=0&id=95e67452&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e67452"]])

export default __exports__